<template>
  <ol
    class="breadcrumbs critical-component-clear body-2"
    :class="[
      $blockClass(blockClass, 'breadcrumbs'),
      {
        'is-loading': state === 'loading',
      }
    ]"
  >
    <li
      class="breadcrumbs__list-item"
      :class="$blockClass(blockClass, 'breadcrumbs__list-item')"
    >
      <a
        class="breadcrumbs__link"
        :class="$blockClass(blockClass, 'breadcrumbs__link')"
        :href="`${storeUrl}${$variable('routes.root')}`"
        v-text="$string('general.breadcrumb.home')"
      />
    </li>

    <li
      v-if="
        template === 'product' &&
          ((collectionTitle && collectionUrl) || state === 'loading')
      "
      class="breadcrumbs__list-item"
    >
      <a
        class="breadcrumbs__link"
        :href="collectionUrl"
      >
        <span
          class="visually-hidden"
          v-text="collectionTitle"
        />

        <span
          aria-hidden="true"
          v-text="truncate(collectionTitle)"
        />
      </a>
    </li>

    <li
      class="breadcrumbs__list-item"
      :class="$blockClass(blockClass, 'breadcrumbs__list-item')"
    >
      <span
        class="breadcrumbs__item"
        :class="$blockClass(blockClass, 'breadcrumbs__item')"
        :style="{ animationDelay: animationDelay }"
      >
        <span
          class="visually-hidden"
          v-text="name"
        />

        <span
          aria-hidden="true"
          :title="name"
          v-text="truncate(name)"
        />
      </span>
    </li>
  </ol>
</template>

<script>

/**
 * Vue: Breadcrumbs (breadcrumbs)
 * -----------------------------------------------------------------------------
 * Breadcrumbs component shared between PDP and collections.
 *
 * @param {String} name - Name shown for the current page on the breadcrumb.
 * @param {String} state - Parent template's loading state.
 * @param {String} [template] - Where it's shown, `product`, `collection`, etc.
 * @param {Boolean} [useCollectionPath] - If collection is in URL, add to
 * breadcrumbs
 *
 */
import { values as timings } from '~/config/timings'

export default {
  name: 'Breadcrumbs',

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    collectionTitle: {
      type: [String, Boolean],
      default: false,
    },
    collectionUrl: {
      type: [String, Boolean],
      default: false,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
    state: {
      type: String,
      default: 'loading',
      required: true,
    },
    template: {
      type: String,
      default: 'product',
    },
    useCollectionPath: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      global: true,
      storeUrl: `https://${cnvs.store.url}`,
    }
  },

  computed: {

    /**
     * Compute animation delay.
     * @returns {Boolean|String}
     */
    animationDelay() {
      if (this.template !== 'product' || this.state !== 'loading') {
        return false
      }

      return `${timings.s}s`
    },
  },

  methods: {

    /**
     * Truncate the breadcrumb text.
     * - Fetches truncation settings from theme settings and truncates string if
     *   functionality is enabled and string length is greater than or equal to
     *   the truncation character count.
     */
    truncate(string) {
      if (!string) {
        return ''
      }

      const truncationEnabled = this.$variable('settings.truncation.enableBreadcrumbTruncation')
      const breadcrumbCharacters = this.$variable('settings.truncation.breadcrumbCharacters')

      if (
        truncationEnabled &&
        breadcrumbCharacters &&
        string.length >= breadcrumbCharacters
      ) {
        return `${string.substring(0, breadcrumbCharacters)}...`
      }

      return string
    },
  },
}
</script>
